module.exports = __webpack_public_path__ + "media/student_lending_center/tile-0af3e819.gif";